<!-- <button
  mat-button
  [matMenuTriggerFor]="menu"
  class="builder-btn"
>
  <div class="label">
    <wm-common-text
      [data]="{text: 'Builder'}"
    ></wm-common-text>
    <ng-container matSuffix>
      <mat-icon class="icon">expand_more</mat-icon>
    </ng-container>
  </div>
</button> -->
<div *ngIf="row">
<button
  mat-raised-button
  color="primary"
  class="split-button"
  type="button"
>
   <div style="display: flex; flex-direction: row; row-gap: 0px;">
    <span
      *ngIf="!row.isArchived; else archivedText"
      (click)="openBuilder()"
      class="split-button-text"
    >
      BUILDER
    </span>

    <ng-template #archivedText>
      <span class="split-disable-button-text">
        BUILDER
      </span>
    </ng-template>

    <span
      class="split-button-icon"
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
    >
      <mat-icon>expand_more</mat-icon>
    </span>
  </div>
</button>

<mat-menu #menu="matMenu" xPosition="before" panelClass="menu-container">
  <button mat-menu-item
    [disabled]="!row.areThereChangesNotPublished || !row.isEnabled"
    (click)="emit('publish')">
      {{ !row.areThereChangesNotPublished || !row.isEnabled ? 'Published' : 'Publish'}}
  </button>
  <button mat-menu-item *ngIf="!row.isArchived && !row.isEnabled" (click)="emit('enable')">Enable</button>
  <button mat-menu-item  *ngIf="!row.isArchived && row.isEnabled" (click)="emit('disable')">Disable</button>
  <button mat-menu-item (click)="row.isArchived ? emit('restore') : emit('archive')">
    {{row.isArchived ? 'Restore' : 'Archive'}}
  </button>
  <button mat-menu-item (click)="emit('history')">History</button>
  <button mat-menu-item *ngIf="!row.isArchived" (click)="emit('copy')">Copy</button>
  <button mat-menu-item *ngIf="!row.isArchived" (click)="emit('makePublic')">
    {{row.visibleToPublic ? 'Hide from Public' : 'Make Public'}}
  </button>
  <button mat-menu-item [disabled]="!canStartApplication()" (click)="emit('start')">Start Application</button>
</mat-menu>
</div>
